import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { type MapLayerKey, DEFAULT_MAP_LAYER } from '@/lib/mapTiles'

type ColorMode = 'light' | 'dark' | 'system'

interface UIState {
  sidebarCollapsed: boolean
  colorMode: ColorMode
  mapLayer: MapLayerKey
  toggleSidebar: () => void
  setSidebarCollapsed: (collapsed: boolean) => void
  setColorMode: (mode: ColorMode) => void
  setMapLayer: (layer: MapLayerKey) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      colorMode: 'system',
      mapLayer: DEFAULT_MAP_LAYER,

      toggleSidebar: () =>
        set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

      setMapLayer: (mapLayer) => set({ mapLayer }),

      setColorMode: (colorMode) => {
        set({ colorMode })
        const root = document.documentElement
        if (colorMode === 'dark') {
          root.classList.add('dark')
          root.classList.remove('light')
        } else if (colorMode === 'light') {
          root.classList.add('light')
          root.classList.remove('dark')
        } else {
          root.classList.remove('dark', 'light')
        }
      },
    }),
    {
      name: 'telematics_ui',
      partialize: (s) => ({
        sidebarCollapsed: s.sidebarCollapsed,
        colorMode: s.colorMode,
        mapLayer: s.mapLayer,
      }),
    }
  )
)
